export const referrerCode = {
  organicSearchGoogle: 11, // Google検索
  organicSearchYahoo: 12, // Yahoo検索
  organicSearchBing: 13, // Bing検索
  other: 90 // その他
};
